import { render, staticRenderFns } from "./DealerActivityLog.vue?vue&type=template&id=7b5feffa&scoped=true"
import script from "./DealerActivityLog.vue?vue&type=script&lang=js"
export * from "./DealerActivityLog.vue?vue&type=script&lang=js"
import style0 from "./DealerActivityLog.vue?vue&type=style&index=0&id=7b5feffa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5feffa",
  null
  
)

export default component.exports